import React, { Children, useCallback } from 'react'
import { styled, Card, CardContent } from '@mui/material'
import { SaveButton, SimpleForm, Toolbar } from 'react-admin'
import { BackButton } from '../buttons'
import { CardFormProps, SimpleMultiCardFormProps } from './type'

const SimpleFormStyled = styled(SimpleForm)(() => ({
  padding: 0,
}))

const ToolBar: React.FC = () => {
  return (
    <Toolbar sx={{ justifyContent: 'space-between' }}>
      <BackButton />
      <SaveButton label='Save' />
    </Toolbar>
  )
}

const CardForm: React.FC<CardFormProps> = ({ children, actions = false, ...props }) => {
  return (
    <Card {...props}>
      <CardContent>{children}</CardContent>
      {actions && actions}
    </Card>
  )
}

export const SimpleMultiCardForm: React.FC<SimpleMultiCardFormProps> = ({
  children,
  toolbarBottom = false,
  ...props
}) => {
  const renderToolbar = useCallback(
    (index, toolbarBottom): JSX.Element | null => {
      if (index + 1 !== Children.count(children)) return null
      return toolbarBottom || <ToolBar />
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toolbarBottom, children],
  )
  if (Children.count(children) === 0) return null
  return (
    <SimpleFormStyled toolbar={false} spacing={4} {...props}>
      {Children.map(children, (child, index) => {
        if (!child && !toolbarBottom) return null
        return (
          <CardForm
            key={index}
            actions={renderToolbar(index, toolbarBottom)}
            sx={{ width: '100%' }}
          >
            {child}
          </CardForm>
        )
      })}
    </SimpleFormStyled>
  )
}
